var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select2-main-wrapper"},[_c('select',{ref:"input",staticStyle:{"width":"100%"}},[_vm._t("default")],2),_c('transition',[_c('div',{ref:"inputBottomDiv"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }